import { Card, CardHeader, CardBody, Text, Button, Flex } from '@backstage/ui';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../core/i18n';

interface ErrorDisplayProps {
  error: Error;
  resetError: () => void;
}

export const KpcErrorDisplay = ({ error, resetError }: ErrorDisplayProps) => {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <Flex align="center" justify="center" style={{ padding: '48px 24px' }}>
      <Card style={{ maxWidth: 600, width: '100%' }}>
        <CardHeader title={t('error.title')} />
        <CardBody>
          <Flex direction="column" gap="4">
            <Text
              variant="body-medium"
              color="secondary"
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {error.message}
            </Text>
            {resetError && (
              <Flex>
                <Button variant="primary" onPress={resetError}>
                  {t('error.retry')}
                </Button>
              </Flex>
            )}
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
};
